import { Microscope, FileCheck2, Snowflake, Stamp } from "lucide-react";

const IMG = "https://images.pexels.com/photos/10514991/pexels-photo-10514991.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const FEATURES = [
  { icon: Microscope, title: "Independent HPLC + MS", text: "Every production lot is assayed by a third-party ISO/IEC 17025 accredited analytical facility — never in-house self-certification." },
  { icon: FileCheck2, title: "Full COA Dossier", text: "Each vial ships with its batch-matched Certificate of Analysis: purity index, retention time, mass-spec confirmation, and lot traceability." },
  { icon: Snowflake, title: "Cold-Chain Handling", text: "Lyophilized compounds are stored at -20°C and dispatched in temperature-monitored, insulated packaging." },
  { icon: Stamp, title: "Gold-Standard Labeling", text: "Compliant research-use labeling on every unit: compound, mass, lot number, reconstitution spec, and RUO statement." },
];

export default function Quality() {
  return (
    <section id="quality" className="bg-white border-y border-slate-200" data-testid="quality-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div className="order-2 lg:order-1 relative">
          <div className="border border-slate-200 p-2 bg-white shadow-sm">
            <img src={IMG} alt="Automated HPLC autosampler verifying peptide batch purity" className="w-full h-72 sm:h-96 object-cover" />
          </div>
          <div className="absolute -top-5 -right-4 sm:-right-6 bg-emerald-600 text-white px-5 py-3 shadow-lg">
            <p className="font-tech text-[10px] uppercase tracking-[0.2em] text-emerald-100">Verification Seal</p>
            <p className="font-tech text-sm font-semibold mt-0.5">ISO/IEC 17025 Accredited</p>
          </div>
        </div>
        <div className="order-1 lg:order-2">
          <p className="font-tech text-xs uppercase tracking-[0.18em] text-sky-700 mb-2">Quality &amp; COA Vault</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900">
            Analytical Rigor Your Institution Can Audit
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Prestigious research programs demand paperwork as pure as the compound. Every lot is
            documented, batch-matched, and independently verified before it ever enters our inventory.
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-6">
            {FEATURES.map((f) => (
              <div key={f.title} className="border border-slate-200 p-5 hover:border-sky-400 transition-colors">
                <f.icon className="h-5 w-5 text-sky-700" />
                <h3 className="font-display font-semibold text-base text-slate-900 mt-3">{f.title}</h3>
                <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
